import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AutcomAppLockService } from 'src/app/components/solicitari/autorizari-comerciale/autcom-app-lock.service';

/**
 * Blocare temporară a secțiunii „Autorizări Comerciale” (HCL Sector 4 nr. 129/2026).
 *
 * Starea vine din AUTCOM Core (GET {basePath}app-locked), nu e hardcodată:
 * când `locked` este `true`, toate rutele modulului (index + fluxurile de depunere,
 * atât cele publice cât și cele din contul cetățeanului) sunt redirecționate către
 * pagina de anunț `indisponibil`.
 *
 * Rămân accesibile dosarele deja înregistrate — vizualizarea/completarea lor se face
 * din `/dashboard/solicitari/view-solicitare/...`, rută aflată în afara acestui modul.
 */
@Injectable({ providedIn: 'root' })
export class AutcomLockedGuard implements CanActivateChild {
    private readonly marker = 'autorizari-comerciale';

    constructor(private router: Router, private appLockService: AutcomAppLockService) { }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const url = state.url.split('?')[0].split('#')[0];

        return this.appLockService.isLocked().pipe(
            map((locked) => {
                if (!locked) {
                    return true;
                }

                // Pagina de anunț trebuie permisă, altfel se ajunge la redirect infinit.
                if (url.includes('/indisponibil')) {
                    return true;
                }

                return this.router.parseUrl(`${this.getSectionBaseUrl(url)}/indisponibil`);
            })
        );
    }

    /**
     * Baza secțiunii, indiferent de punctul de intrare:
     *   /dashboard/solicitari/institutie/autorizari-comerciale
     *   /public/solicitari/autorizari-comerciale
     */
    private getSectionBaseUrl(url: string): string {
        const idx = url.indexOf(this.marker);

        return idx >= 0
            ? url.substring(0, idx + this.marker.length)
            : '/dashboard/solicitari/institutie/autorizari-comerciale';
    }
}
